import { render, staticRenderFns } from "./localUpload.vue?vue&type=template&id=68009560&scoped=true"
import script from "./localUpload.vue?vue&type=script&lang=js"
export * from "./localUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68009560",
  null
  
)

export default component.exports